const initialState = {
  loading: false,
  payload: null,
  error: null
}

export default function detailTransactionReducer(state = initialState, action) {
  switch (action.type) {
    case 'DETAIL_TRANSACTION_BEGIN':
      return {
        ...state,
        loading: true,
        error: null
      }
    case 'DETAIL_TRANSACTION_SUCCESS':
      return {
        ...state,
        loading: false,
        payload: action.payload
      }
    case 'DETAIL_TRANSACTION_FAILURE':
      return {
        ...state,
        loading: false,
        error: action.error
      }
    default:
      return state
  }
}
